module.exports = __webpack_public_path__ + "static/media/l_dot_11.9b97c5a4.png";